/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PatchOperation { 
    operation?: PatchOperation.OperationEnum;
    path?: string;
    value?: object;
}
export namespace PatchOperation {
    export const OperationEnum = {
        Add: 'add',
        Remove: 'remove',
        Replace: 'replace'
    } as const;
    export type OperationEnum = typeof OperationEnum[keyof typeof OperationEnum];
}


